import { render, staticRenderFns } from "./MigrationCard.vue?vue&type=template&id=9900cf3e&scoped=true&"
import script from "./MigrationCard.vue?vue&type=script&lang=js&"
export * from "./MigrationCard.vue?vue&type=script&lang=js&"
import style0 from "./MigrationCard.vue?vue&type=style&index=0&id=9900cf3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9900cf3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VFileInput,VIcon,VRow})
